//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.Geometry.js";
import "../CAM/CAM.BlankIpwMultipleSource.js";
let d=[[[0,"AutoBlockOffsetNegativeX",1,0],[0,"AutoBlockOffsetNegativeY",1,0],[0,"AutoBlockOffsetNegativeZ",1,0],[0,"AutoBlockOffsetPositiveX",1,0],[0,"AutoBlockOffsetPositiveY",1,0],[0,"AutoBlockOffsetPositiveZ",1,0],[0,"BlankCreationType",1,0],[0,"BlankDefinitionType",1,0],[0,"BlankIpw",0,"CAM.BlankIpw",0],[1,"BlankIpwMultipleSource",0,"CAM.BlankIpwMultipleSource",0],[0,"BlankToggleValue",1,0],[0,"BlockHeight",1,0],[0,"BlockLength",1,0],[0,"BlockOffsetXNegative",1,0],[0,"BlockOffsetXPositive",1,0],[0,"BlockOffsetYNegative",1,0],[0,"BlockOffsetYPositive",1,0],[0,"BlockOffsetZNegative",1,0],[0,"BlockOffsetZPositive",1,0],[0,"BlockWidth",1,0],[0,"Csys",1,"CartesianCoordinateSystem",0],[0,"CylinderDiameter",1,0],[0,"CylinderHeight",1,0],[0,"CylinderInheritAttributes",1,0],[0,"CylinderNegativeHeightOffset",1,0],[0,"CylinderPositiveHeightOffset",1,0],[0,"DirectionType",1,0],[0,"InheritAttributes",1,0],[0,"IpwPositionCsys",1,"CoordinateSystem",0],[0,"IpwPositionType",1,0],[0,"OffsetFromPart",1,0],[0,"OffsetNegativeZ",1,0],[0,"OffsetPositiveZ",1,0],[0,"OrientationType",1,0],[0,"PartBoxToggleValue",1,0],[0,"PmiAttribute",1,0],[0,"Vector",1,"Direction",0]],[[[],"ResetBlockSize",{},0,0],[[],"ResetCylinderSize",{},0,0]],[]];
SPLM.CAM.GeometryGroup = class extends SPLM.CAM.Geometry{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.GeometryGroup";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.GeometryGroup.BlankDefinitionTypes = Object.freeze({
    "FromGeometry" : "FromGeometry", "OffsetFromPart" : "OffsetFromPart", "AutoBlock" : "AutoBlock", "Ipw" : "Ipw", "BoundingCylinder" : "BoundingCylinder", "PartOutline" : "PartOutline", "PartConvexHull" : "PartConvexHull"});

SPLM.CAM.GeometryGroup.OrientationTypes = Object.freeze({
    "Mcs" : "Mcs", "Specify" : "Specify"});

SPLM.CAM.GeometryGroup.DirectionTypes = Object.freeze({
    "Zm" : "Zm", "Specify" : "Specify"});

SPLM.CAM.GeometryGroup.PositionTypes = Object.freeze({
    "Part" : "Part", "Coordinate" : "Coordinate"});

SPLM.CAM.GeometryGroup.BlankCreationTypes = Object.freeze({
    "Body" : "Body", "Component" : "Component"});

export default SPLM;